import React from "react";
import { MDBCol } from "mdbreact";

//Components
import Navbar from "../../components/Navbar_inicio";
import FooterPage from "../../components/Footer";

//CSS
import "./Inicio.css";

//Landing sections
import WhyChooseTovo from "./sections/WhyChooseTovo";
import Opinions from "./sections/Opinions";
import Start from "./sections/Start";
import WhoWeAre from "./sections/WhoWeAre";
import Reward from "./sections/Reward";

// // Google analytics
// import ReactGA from 'react-ga';
// ReactGA.initialize('UA-000000-01');
// ReactGA.pageview(window.location.pathname + window.location.search);

class Inicio extends React.Component {
  render() {
    return (
      <div id="appp">
        <MDBCol style={{ padding: "0px" }}>
          <Navbar />
          <Start />
          <WhyChooseTovo />
          <WhoWeAre />
          <Opinions />
          <Reward />

          {/* <HowWorks /> */}
          {/* <PreferUs /> */}
          {/* <PassengerSafety /> */}
          {/* <DriverSafety /> */}
          {/* <Covid /> */}
          {/* <FAQ /> */}
          {/* <DownloadApp /> */}
          <FooterPage />
        </MDBCol>
      </div>
    );
  }
}

export default Inicio;
